export function debugAuthSnapshot(label, extra = {}) {
  try {
    if (process.env.NODE_ENV !== "development") return;
    if (typeof window === "undefined") return;

    const w = window;
    w.__authDebugSeq = (w.__authDebugSeq || 0) + 1;

    const safeLen = (v) => (typeof v === "string" ? v.length : 0);

    const ss = (() => {
      try {
        return {
          accessTokenLen: safeLen(sessionStorage.getItem("accessToken")),
          idTokenLen: safeLen(sessionStorage.getItem("idToken")),
          emailPresent: !!sessionStorage.getItem("email"),
          jobTitle: sessionStorage.getItem("jobTitle") || null,
          tokenExpiration: sessionStorage.getItem("tokenExpiration") || null,
        };
      } catch {
        return { error: "sessionStorage_unavailable" };
      }
    })();

    const ls = (() => {
      try {
        const keys = Object.keys(localStorage);
        const msalKeys = keys.filter(
          (k) =>
            k.startsWith("msal.") ||
            k.includes("msal") ||
            k.includes("b2c") ||
            k.includes("aad") ||
            k.includes("login.windows") ||
            k.includes("b2clogin"),
        );
        return {
          msalKeyCount: msalKeys.length,
        };
      } catch {
        return { error: "localStorage_unavailable" };
      }
    })();

    const entry = {
      seq: w.__authDebugSeq,
      t: Date.now(),
      label,
      href: w.location?.href,
      pathname: w.location?.pathname,
      hash: w.location?.hash,
      ss,
      ls,
      ...extra,
    };

    w.__authDebugLog = w.__authDebugLog || [];
    w.__authDebugLog.push(entry);

    // Keep the log bounded to avoid memory growth in dev.
    if (w.__authDebugLog.length > 300) {
      w.__authDebugLog.splice(0, w.__authDebugLog.length - 300);
    }

    // Console logging disabled - entries still stored in window.__authDebugLog
    // To re-enable: uncomment the console.info line below
    // console.info("[auth-debug]", entry);
  } catch {
    // Never let debug logging crash the app.
  }
}

